module.exports = __webpack_public_path__ + "main-logged-out-58e5f421/basic_984-5c35c51bf96aa09ce9afb6fc33670d24.png";